
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".c-variants-product__item-wrapper").forEach(wrapper => {
    const variants = Array.from(wrapper.querySelectorAll(".c-variants-product__variant"));
    const showMore = wrapper.querySelector("#show-more-variants");

    const isOutOfStock = (v) =>
      v.querySelector("input")?.classList.contains("out-of-stock");

    const hasDiscount = (v) =>
      v.querySelector("input")?.dataset.variantHasDiscount === "true";

    // 1. Quitar checked a todos antes de ordenar
    variants.forEach(v => {
      const input = v.querySelector("input");
      if (input) {
        input.checked = "";
        input.classList.remove("active")
      }
    });

    // 2. Separar por stock (manteniendo orden original)
    const disponibles = variants.filter(v => !isOutOfStock(v));
    const sinStock = variants.filter(v => isOutOfStock(v));

    // 3. Regla especial: si todas las disponibles tienen descuento → no ordenar por descuento
    const todasDisponiblesConDescuento =
      disponibles.length > 0 && disponibles.every(v => hasDiscount(v));

    let ordenFinalDisponibles;

    if (todasDisponiblesConDescuento) {
      ordenFinalDisponibles = disponibles;
    } else {
      const conDescuento = disponibles.filter(v => hasDiscount(v));
      const sinDescuento = disponibles.filter(v => !hasDiscount(v));
      ordenFinalDisponibles = [...conDescuento, ...sinDescuento];
    }

    // 4. Limpiar DOM
    variants.forEach(v => v.remove());

    const anchor = showMore || null;

    // 5. Insertar disponibles
    ordenFinalDisponibles.forEach(v => wrapper.insertBefore(v, anchor));

    // 6. Insertar sin stock al final
    sinStock.forEach(v => wrapper.insertBefore(v, anchor));

    // 7. Marcar checked en el PRIMER disponible visible
    if (ordenFinalDisponibles.length > 0) {
      const firstInput = ordenFinalDisponibles[0].querySelector("input");
      if (firstInput) {
        firstInput.checked = "checked";
        firstInput.classList.add("active")
        firstInput.click();
      }
    }
  });
});




/*
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.c-variants-product__item-wrapper').forEach(wrapper => {
    const variants = Array.from(wrapper.querySelectorAll('.c-variants-product__variant'));
    const showMore = wrapper.querySelector('#show-more-variants');
    const disponibles = variants.filter(v => !v.querySelector('input').classList.contains('out-of-stock'));
    const sinStock = variants.filter(v => v.querySelector('input').classList.contains('out-of-stock'));

    variants.forEach(v => v.remove());
    disponibles.forEach(v => wrapper.insertBefore(v, showMore));
    sinStock.forEach(v => wrapper.insertBefore(v, showMore));
  });
});
*/
